import { BookOpen, Zap, TrendingUp, Globe, Megaphone } from "@/components/icons";
import * as Yup from "yup";

export const categoryMeta: Record<string, { color: string; icon: React.ReactNode }> = {
  "Web Scraping & Automation": { color: "#5b8cff", icon: <Zap size={12} /> },
  "Proxies & Anonymity": { color: "#22d3ee", icon: <Globe size={12} /> },
  "Tech Tutorials & Programming": { color: "#34d399", icon: <BookOpen size={12} /> },
  "Updates & Announcements": { color: "#ec4899", icon: <Megaphone size={12} /> },
  Partnerships: { color: "#f59e0b", icon: <TrendingUp size={12} /> },
};

export function getCategoryColor(cat: string) {
  return categoryMeta[cat]?.color ?? "color-mix(in srgb, var(--foreground) 60%, transparent)";
}

export const TOC_ITEMS = [
  { id: "why-js-heavy", label: "Why JS-heavy sites are harder to scrape" },
  { id: "tool-selection", label: "Choosing the right headless browser" },
  { id: "proxy-strategy", label: "Proxy rotation strategies" },
  { id: "benchmarks", label: "Benchmarks & success rates" },
  { id: "putting-it-together", label: "Putting it all together" },
  { id: "conclusion", label: "Conclusion" },
];

export const postNewsletterSchema = Yup.object({
  email: Yup.string().email("Enter a valid email").required("Required"),
});
